import CollectionsService from '@/services/collection/CollectionsService'

const localContext = JSON.parse(localStorage.getItem('collectionContext'))

const initContext = localContext || {
  collectionList: [],
  currentCollection: null,
  currentCollectionIndex: null
}

export default {
  namespaced: true,
  state: initContext,
  getters: {
    collectionList: state => state.collectionList,
    currentCollection: state => state.currentCollection,
    currentCollectionIndex: state => state.currentCollectionIndex
  },
  actions: {
    refreshCollections ({ state, commit }) {
      return CollectionsService.getAllForView()
        .then(list => {
          commit('SET_COLLECTIONS', list)
          commit('SET_COLLECTION_CONTEXT_INDEX', 0)
        })
    },
    setCurrentCollectionIndex ({ commit }, index) {
      commit('SET_COLLECTION_CONTEXT_INDEX', index)
    }
  },
  mutations: {
    SET_COLLECTIONS (state, list) {
      state.collectionList = list
      localStorage.setItem('collectionContext', JSON.stringify(state))
    },
    SET_COLLECTION_CONTEXT_INDEX (state, index) {
      state.currentCollectionIndex = index
      state.currentCollection = state.collectionList[index]
      localStorage.setItem('collectionContext', JSON.stringify(state))
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/collection/collectionContext.js